//用于暴露store对象 一个应用只有一个

//引入reduxjs/toolkit 最新综合redux的工具包
import { configureStore } from '@reduxjs/toolkit'
import publicReducer from './actions/getAppPublicData'
import pageReducer from './actions/getAppPageData'

export const store = configureStore({
  reducer: {
    public: publicReducer,    // 公共配置
    page: pageReducer,        // 页面配置
  },
})
